import { apiClient } from 'pobble-components/dist/api'

const apiGetInvitations = params =>
  apiClient.get(`/v3/me/assessment_file_invitations`, { params })

const apiRemoveCurrentInvitation = invitationId =>
  apiClient.put(`/v3/assessment_file_invitations/${invitationId}/archive`)

const apiMarkAsSeen = id =>
  apiClient.put(`/v3/assessment_file_invitations/${id}/mark_as_seen`)

const apiMarkAsUnseen = id =>
  apiClient.put(`/v3/assessment_file_invitations/${id}/mark_as_unseen`)

export {
  apiGetInvitations,
  apiRemoveCurrentInvitation,
  apiMarkAsSeen,
  apiMarkAsUnseen
}
